import React from 'react';

import {
    FormControl,
    FormControlLabel,
    FormHelperText,
    Checkbox,
} from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';

const ReactHookFormCheck = ({
    color = 'primary',
    control,
    disabled,
    id,
    label,
    labelPlacement,
    name,
    onChange,
    sxFormLabel,
}) => {
    const onChangeAction = (e, onChangeField) => {
        onChangeField(e);
        if (onChange) onChange(e.target.checked);
    };

    return (
        <Controller
            control={control}
            name={name}
            render={({
                field: { onChange: onChangeField, value },
                fieldState: { error },
            }) => (
                <FormControl error={Boolean(error)}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                color={color}
                                checked={Boolean(value)}
                                disabled={disabled}
                                id={id}
                                onChange={(e) =>
                                    onChangeAction(e, onChangeField)
                                }
                            />
                        }
                        label={label}
                        labelPlacement={labelPlacement}
                        sx={{ margin: !label ? 0 : undefined, ...sxFormLabel }}
                    />

                    {Boolean(error) && (
                        <FormHelperText type="error">
                            {error?.message}
                        </FormHelperText>
                    )}
                </FormControl>
            )}
        />
    );
};

ReactHookFormCheck.propTypes = {
    color: PropTypes.string,
    control: PropTypes.object,
    disabled: PropTypes.bool,
    id: PropTypes.string,
    label: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    labelPlacement: PropTypes.string,
    name: PropTypes.string,
    onChange: PropTypes.func,
    sxFormLabel: PropTypes.object,
};

export default ReactHookFormCheck;
